module.exports = __webpack_public_path__ + "img/ham_icon_004.72486baf.png";